import React, { useEffect, useState } from 'react';

const CountdownTimer = ({ durationInSeconds, setMockEnd, getCurrentTime }) => {
  const [remainingTime, setRemainingTime] = useState(durationInSeconds);

  useEffect(() => {
    const intervalId = setInterval(() => {
      // Update the remaining time every second
      setRemainingTime((prevTime) => (prevTime > 0 ? prevTime - 1 : 0));
    }, 1000);
    // Clean up the interval when the component is unmounted
    return () => clearInterval(intervalId);
  }, [durationInSeconds]);

  useEffect(() => {
    if (getCurrentTime) {
      getCurrentTime(durationInSeconds - remainingTime);
    }
  }, [remainingTime]);
  if (remainingTime == 0) {
    setMockEnd(true);
  }
  // Convert remaining time to hours, minutes, and seconds
  const hours = Math.floor(remainingTime / 3600);
  const minutes = Math.floor((remainingTime % 3600) / 60);
  const seconds = remainingTime % 60;

  return (
    <div className='d-flex mt-2'>
      <div
        className={'timerbox ' + (minutes < 1 ? 'timerred' : '')}
      >{`${hours}h ${minutes}m ${seconds}s`}</div>
    </div>
  );
};

export default CountdownTimer;
